/* Carga de archivo:   elemento que carga un archivo a la vez */

//*react- recursos
import React, { useState,useEffect } from "react";
import Swal from 'sweetalert2';

//*componentes-utiles
import { A, SlidingPanel, Button } from "@reactjscomponentrepository/frontend-components/lib/components";

/* import CargaArchivo from "../../../componentes/CargaArchivo"; */

//*clases 
import "./splidingPanel.css"
//*datos

//*archivos (imagenes y elementos necesarios para la rutina)
import EjemploContenido from "./EjemploContenido"

//*api's (servicios y store)

//*store's

//*vista
export default function Ejemplo(){
  //*api store

  //*store's
  
  //*data 

  //*constantes y variables

  //*usestate
  const [abreSP, setAbreSP] = useState(false);
  const [incompletaSP, setIncompletaSP] = useState(false);  //usada para saber si esta completa la carga SP y activar botón aceptar

  //*useEffect

  //*funciones
    
    const botonAceptarSlidingPanel = () => {
      alert('botón aceptar');
    }

    const botonCierraSlidingPanel = (opcBtnAcepReg:any) => {
      if ((opcBtnAcepReg==="reg" || opcBtnAcepReg==="clo") && incompletaSP){
        Swal.fire({
          text: "",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          width: '40%',
          html: '<div>' + 'Se detectaron cambios sin guardar. ¿Está seguro de salir de la edición de información?' + '</div>'
        }).then((result) => {
          if (result.isConfirmed){ 
            setAbreSP(!abreSP);
          }
          else
            return;
        })
      }
      else{
        setAbreSP(!abreSP);
        }
    }
  
    return (
      <div  className="container container-Vista">
          <h1>Ejemplo... de SlidingPanel (ventana modal):</h1>
          <label>
            Aquí no tenemos componente adicional, se ejecuta todo en esta misma página
          </label>
          <br/>
          <Button type='button' onClick={()=>setAbreSP(!abreSP)} className='mr-2' > Ejecutar SlidingPanel </Button>

          <SlidingPanel isOpen={abreSP} type='right' title={'encabezado'} 
                        closeClick={()=>botonCierraSlidingPanel("reg")} size={80} >
                          <EjemploContenido />
         {/* 
            <div className="contenidoSlidingPanel">
              aquí va el contenido <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
              ...<br></br><br></br><br></br><br></br><br></br><br></br><br></br>
              <br></br><br></br><br></br><br></br><br></br><br></br><br></br>...
            </div> 

            <div className="pieSlidingPanel">
              <div className="pieBotonesSlidingPanel">
                <Button type='button' onClick={botonAceptarSlidingPanel} className='mr-2' 
                        disabled={ incompletaSP ? false:true }> Aceptar </Button>
                <A className='text-progress' onClick={()=>botonCierraSlidingPanel("reg")}>Regresar</A> 
              </div>
            </div>   */}

          </SlidingPanel>


          <br/>
      </div>
    );
}
